<template>
  <div class="update-dialog">
    <el-dialog :title="'修改班级考试人数：' + classExamInfo.className + classExamInfo.title"
      :visible.sync="updateExamClassDialogShow" width="400px" :before-close="dialogClose" @open="dialogOpen">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="考试人数" prop="people">
          <el-input v-model="ruleForm.people" type="number"></el-input>
        </el-form-item>
      </el-form>
      <div style="display: flex; justify-content: center; margin-top: 50px">
        <el-button type="primary" @click="updateExamClassConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    "updateExamClassDialogShow",
    "classExamInfo",
    "examPeople"
  ],
  data() {
    return {
      ruleForm: {
        people: "",
      },
      rules: {
        people: [
          { required: true, message: "请输入考试人数", trigger: "blur" },
        ],
      }
    };
  },
  methods: {
    dialogOpen() {
      this.ruleForm.people = this.examPeople;
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:updateExamClassDialogShow", false);
    },
    updateExamClassConfirm() {
      let data = {
        examInfoId: this.classExamInfo.id,
        classId: this.classExamInfo.classId,
        examPeople: this.ruleForm.people
      };
      this.put(this.$url.updateExamClass, data).then((res) => {
        if (res.code != 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.dialogClose();
        this.$emit("updateExamClassSuccess");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./updateExamClassDialog.scss";
</style>